import {useEffect} from 'react';
import {UserFlowStep} from '../../Facade/UserFlow/BaseUserFlow';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import {useUserFlowState} from '../../Components/Context/UserFlow/UserFlowContext';
import {useUiState} from '../../Components/Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Components/Context/UserInterface/UserInterfaceActionTypes';
import {useTaopix} from '../../Components/Context/TaopixContext';
import {useErrorBoundary} from 'react-error-boundary';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';
import {SettingsActions} from '@taopix/taopix-core';
import useSettings from '../useSettings';
import {ReducerState, SaveArgs} from '@taopix/taopix-core/dist/types/types';

export const useSaveObserver = (server: APIServer) => {
  const ui = useUiState();
  const userFlow = useUserFlowState();
  const app = useTaopix();
  const settings = useSettings();
  const {showBoundary} = useErrorBoundary();

  const stepActive = userFlow.isStepActive(UserFlowType.Save, UserFlowStep.Save);

  useEffect(() => {
    let controller;
    if (stepActive && !ui.state.busy) {
      controller = new AbortController();
      app.core
        .get('stateManager')
        .call<SaveArgs, ReducerState>('save', {
          projectName: ui.state.projectNaming.editName
            ? ui.state.projectNaming.projectName
            : undefined,
          showSaveOverlay: true,
          saveTemplate: true,
        })
        .then(() => {
          if (ui.state.projectNaming.editName) {
            ui.dispatch(
              UserInterfaceActions.setProjectNameDialog({
                ...ui.state.projectNaming,
                editName: false,
              })
            );

            settings.dispatch(
              SettingsActions.setDesignerSettings({
                ...settings.state,
                project: {
                  ...settings.state.project,
                  name: ui.state.projectNaming.projectName,
                },
              })
            );

            // Update title.
            document.title = ui.state.projectNaming.projectName;
          }
          ui.dispatch(UserInterfaceActions.setSaveCount(ui.state.saveCount + 1));
        })
        .catch(error => {
          showBoundary(error);
        })
        .finally(() => {
          userFlow.setNextStep();
        });
    }

    return () => {
      if (controller instanceof AbortController && !ui.state.busy) {
        controller.abort();
      }
    };
  }, [stepActive, ui.state.busy]);

  return;
};
